import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { loggingInterceptor } from './core/interceptors/logging.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';

// Register German locale for date/currency pipes
registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21+ defaults to zoneless change detection; this app still relies
    // on zone.js (polyfill in angular.json), which was the default up to v20.
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        loggingInterceptor,
        authInterceptor
      ]),
    ),
    { provide: LOCALE_ID, useValue: 'de' }
  ]
};
